// useAuth.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useAuth = (redirectTo = '/') => {
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('jwt_token');
        if (!token) {
            navigate(redirectTo);
        }
    }, [navigate, redirectTo]);
};

export default useAuth;